export default {
  reset: ({ item, currentPassword, errors }) => {
    item.token = null;
    item.avatar = null;
    item.first_name = null;
    item.last_name = null;
    item.email = null;
    item.password = null;

    delete item.company;

    currentPassword = null;

    errors.splice(0, errors.length);
    sessionStorage.removeItem('token');
  },
  resetPassword: ({ item }) => {
    item.password = null;
  },
  resetCurrentPassword: (state) => {
    state.currentPassword = null;
  },
  resetErrors: ({ errors }) => {
    errors.splice(0, errors.length);
  },
  setUser: ({ item }, user) => {
    item.avatar = user.avatar ? user.avatar.path : null;
    item.first_name = user.first_name;
    item.last_name = user.last_name;
    item.email = user.email;

    if (user.company) {
      item.company = user.company;
    }
  },
  setCompany: ({ item }, company) => {
    item.company = company;
  },
  setToken: ({ item }, token) => {
    item.token = token;
    sessionStorage.setItem('token', token);
  },
  setAvatar: ({ item }, avatar) => {
    item.avatar = avatar.path;
  },
  setFirst_name: ({ item }, first_name) => {
    item.first_name = first_name;
  },
  setLast_name: ({ item }, last_name) => {
    item.last_name = last_name;
  },
  setEmail: ({ item }, email) => {
    item.email = email;
  },
  setPassword: ({ item }, password) => {
    item.password = password;
  },
  setCurrentPassword: (state, password) => {
    state.currentPassword = password;
  },
  addError: ({ errors }, error) => {
    errors.push(error);
  },
  setErrors: (state, errors) => {
    state.errors = errors;
  },
};
